import Typography from 'src/components/Text/Text';
import React from 'react';
import { View, StyleSheet, Image, TouchableOpacity } from 'react-native';
import TpiSlider from 'src/components/Slider/Slider';
import deleteIcon from 'src/assets/delete-blue-3x.png';
import { themes } from 'src/theme/theme';

type CommoditiesSliderProps = {
  value: number;
  onValueChange: (value: number) => void;
  title: string;
  onDelete: (index: number) => void;
  index: number;
  testID?: string;
};

const CommoditiesSlider: React.FC<CommoditiesSliderProps> = ({
  value,
  onValueChange,
  title,
  onDelete,
  index,
  testID,
}) => {
  return (
    <View style={styles.container} testID={testID}>
      <View style={styles.top}>
        <Typography variant="h4">{title}</Typography>
        <TouchableOpacity onPress={() => onDelete(index)} style={styles.iconContainer}>
          <Image source={deleteIcon} style={styles.icon} accessibilityLabel={`${testID}-delete`} />
        </TouchableOpacity>
      </View>
      <TpiSlider value={value} onValueChange={onValueChange} testID={`${testID}-slider`} />
    </View>
  );
};
export default CommoditiesSlider;
const styles = StyleSheet.create({
  container: {
    width: '100%',
    height: 108,
  },
  top: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  iconContainer: {
    width: 32,
    height: 32,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: themes.light.gray_blue[6],
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: {
    width: 13.47,
    height: 13,
  },
});
